import { createElement } from 'react';
import { a as __rest, _ as __assign } from '../../tslib.es6-e75ac550.js';
import { p as Chip$1 } from '../../index.esm-3174114c.js';
import 'react-measure';
import 'throttle-debounce';
import 'react-dom';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'react-router-dom';
import 'intersection-observer';
import 'react-html-parser';

var styles = {"chip--gu":"gu-ec-chip--gu","chipGu":"gu-ec-chip--gu","fr-ec-chip__label--long-text":"gu-ec-fr-ec-chip__label--long-text","frEcChipLabelLongText":"gu-ec-fr-ec-chip__label--long-text"};

var Chip = function Chip(_a) {
  var props = __rest(_a, ["iconBrand"]);

  return /*#__PURE__*/createElement(Chip$1, __assign({
    iconBrand: "gu-ec-",
    className: styles.chipGu
  }, props));
};
Chip.displayName = 'Chip';

export { Chip };
